import { Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CallCenterService } from 'src/app/services/call-center.service';
import { ItdoseService } from 'src/app/services/itdose.service';
import { MessageServiceService } from "src/app/services/message-service.service";
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-it-dose-url',
  templateUrl: './it-dose-url.component.html',
  styleUrls: ['./it-dose-url.component.scss']
})
export class ITDoseURLComponent implements OnInit, OnDestroy {
  packageDetailsModalRef: BsModalRef;
  @ViewChild('packageDetailsTemplate', { static: false}) packageDetailsTemplate: TemplateRef<any> ;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  }
  loadingFlag: boolean = false;
  loadingFlagAppt: boolean = false;
  dobMaxDate: Date;
  slotsData: any[];
  yearRangeDob = "";
  minDate: Date = new Date();
  maxDate: Date = new Date();
  ITDoseForm: FormGroup;
  ITDoseSub: Subscription;
  selectedUHIDDetails: any;
  isNewUser: boolean = false;
  callType: number;
  submitted: boolean;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;
  callerStatusAutoId = 0;
  isSelectedCallBackOption = false;
  isInboundCallNewUser = false;
  isSelectedStatusUpdate = false;
  isSelectedAppointment = false;
  selectedCallStatusName;
  selectedCallStatusId;
  citiesData = [];
  cityId: any;
  cityNameData: any;
  areaPincodeData = [];
  selectedAppointmentDate: any;
  selectedDob: any;
  allSlotsData = [];
  slotsOnId: any;
  packagesData: any[] = [];
  dropdowntests: any[] = [];
  packageItemTestsData = [];
  address: string;
  googlePlaces = [];
  locationDetails: any;
  price: any;
  titlesData = [];
  titleOnId: any;
  countryCodesData: any[] = [];
  countryCode: any;
  genderData = [];
  genderOnId: any;
  slotsReq = [];
  ViewselectedPackage: boolean = false;
  patientDetails = [];
  testDetails = [];
  CheckAreaServiceabilityDetails: any;
  areaId: any;
  areaPincodeDetails: any;
  selectedSlotDateForAppt: any;
  totalPrice: number;
  viewPackagesTotalPrice: number;
  stateId: number = 0;
  userName: string;

  constructor(private formBuilder: FormBuilder,
    private callCenterService: CallCenterService,
    private ITDoseService: ItdoseService,
    private messageService: MessageServiceService,
    private commonService: CommonService,
    private modalService: BsModalService,) {
    let date = new Date();
    this.dobMaxDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - 1
    );
    this.yearRangeDob = `${date.getFullYear() - 100}:${date.getFullYear()}`;
  }

  ngOnInit() {
    this.userName = localStorage.getItem("username");
   // console.log(this.userName, "Username");
    this.maxDate.setDate(this.maxDate.getDate() + 3);

    this.getITDoseForm();
   // this.getTitlesData()
  }

  ngOnDestroy() {
    this.ITDoseSub.unsubscribe();
  }


  getITDoseForm() {
    //IT Dose booking Form
    this.ITDoseForm = this.formBuilder.group({
      salutation: ['', [Validators.required]],
      FirstName: ['', [Validators.required]],
      LastName: ['', [Validators.required]],
      Email: ['', [Validators.pattern(/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)]],
      countryCode: ['', [Validators.required]],
      MobileNumber: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      AlternateMobileNumber: ['', [Validators.pattern('[0-9]{10}')]],
      Gender: ['', [Validators.required]],
      DateOfBirth: ['', [Validators.required]],
      Address: ['', [Validators.required]],
      Location: ['', [Validators.required]],
      Area: ['', [Validators.required]],
      TestDate: ['', [Validators.required]],
      Slot: ['', [Validators.required]],
      City: ['', [Validators.required]],
      Test: ['', [Validators.required]],
      Price: ['', [Validators.required]],
      Remarks: [''],
    });
    this.ITDoseForm.get('TestDate').disable();
    this.ITDoseForm.get('Slot').disable();

    this.CheckPrimaryCases();
  }

  leadId;
  CheckPrimaryCases() {
    //this method get the selected call status data from service
    this.ITDoseSub = this.callCenterService.selectedCallStatus.subscribe(value => {
      this.isSelectedAppointment = true;
      this.leadId = value.LeadId;
      this.isNewUser = value.IsNewUser;
      this.callType = value.CallTypeId;
      this.callerStatusAutoId = value.CallerStatusAutoId;
      this.selectedUHIDDetails = value.UHIDDetails;
      this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
      this.selectedCallStatusName = value.CallStatus["statusName"];
      if (this.selectedCallStatusId == 37 && this.callType == 1 && this.isNewUser) { // inbound new user + create appt
        this.isSelectedAppointment = true;
        this.isInboundCallNewUser = true;
        this.loadBasicDetailsOfLead();
      }
      else if (this.selectedCallStatusId == 37) { //outbound+inbound existed user or new user.
        this.isSelectedAppointment = true;
        this.isInboundCallNewUser = false;
        if (this.isNewUser && this.callType == 2) { // for lead new user in outbound call only
          this.loadBasicDetailsOfLead();
        } else {
          this.loadBasicDetails();
        }
      }
    });
    this.getTitlesData();
  }

  loadBasicDetailsOfLead() {

    if (this.selectedUHIDDetails.firstName) {
      this.ITDoseForm.controls["FirstName"].setValue(this.selectedUHIDDetails.firstName);
    }
    if (this.selectedUHIDDetails.lastName) {
      this.ITDoseForm.controls["LastName"].setValue(this.selectedUHIDDetails.lastName);
    }
    if (this.selectedUHIDDetails.emailId) {
      this.ITDoseForm.controls["Email"].setValue(this.selectedUHIDDetails.emailId);
    }
    if (this.selectedUHIDDetails.phoneNo) {
      this.ITDoseForm.controls["MobileNumber"].setValue(this.selectedUHIDDetails.phoneNo);
    }
  }

  loadBasicDetails() {
    if (this.selectedUHIDDetails.firstName) {
      this.ITDoseForm.controls["FirstName"].setValue(this.selectedUHIDDetails.firstName);
      // this.ITDoseForm.controls["FirstName"].disable();
    }
    if (this.selectedUHIDDetails.lastName) {
      this.ITDoseForm.controls["LastName"].setValue(this.selectedUHIDDetails.lastName);
      // this.ITDoseForm.controls["LastName"].disable();
    }
    if (this.selectedUHIDDetails.dateOfBirth) {
      let dob = this.selectedUHIDDetails.dateOfBirth.split("/");
      this.ITDoseForm.controls["DateOfBirth"].setValue(new Date(dob[2], dob[1] - 1, dob[0]));
      this.ITDoseForm.controls["DateOfBirth"].disable();
    }

    if (this.selectedUHIDDetails.emailId) {
      this.ITDoseForm.controls["Email"].setValue(this.selectedUHIDDetails.emailId);
      this.ITDoseForm.controls["Email"].disable();
    }

    if (this.selectedUHIDDetails.mobileNumber) {
      this.ITDoseForm.controls["MobileNumber"].setValue(this.selectedUHIDDetails.mobileNumber);
      this.ITDoseForm.controls["MobileNumber"].disable();
    }
  }

  getTitlesData() {
    //debugger;
    // To get the titles data
    this.titlesData = [];
    this.loadingFlag = true;
    this.ITDoseService.getTitles().subscribe((res: any) => {
      if (res.response && res.response.length > 0) {
        this.titlesData = res.response;
      }
      else {
        this.titlesData = [];
        this.messageService.showErrorMessage("No data found");
      }
      this.getAllCountryCodes();
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })

  }

  getTitlesOnId(event) {
    this.titleOnId = event;
    this.getGenderData();
  }

  getAllCountryCodes() {
    //To get the country codes for mobile number
    this.countryCodesData = [];
    this.commonService.getCountryCodes().subscribe((res: any) => {
      for (let key in res) {
        if (res[key].calling_code == '91') {
          this.ITDoseForm.patchValue({ countryCode: res[key].calling_code = "+" + res[key].calling_code });
        }
        this.countryCodesData.push(res[key]);
      }
    });
    this.getCitiesData();
  }

  getCountryCode(event) {
    this.countryCode = event;
  }

  getGenderData() {
    // To get the gender data
    this.genderData = [];
    this.loadingFlag = true;
    this.ITDoseService.getGender().subscribe((res: any) => {
      if (res.response && res.response.length > 0) {
        this.genderData = res.response;
        if (this.titleOnId == 'Mr.' || this.titleOnId == 'Master.') {
          this.ITDoseForm.patchValue({ Gender: this.genderData[0].name });
        }
        else if (this.titleOnId == 'Mrs.' || this.titleOnId == 'Miss.' || this.titleOnId == 'Baby.') {
          this.ITDoseForm.patchValue({ Gender: this.genderData[1].name });
        }
        else {
          this.ITDoseForm.patchValue({ Gender: "" });
        }
      }
      else {
        this.genderData = [];
        this.messageService.showErrorMessage("No data found");
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })

  }

  getGenderOnId(event) {
    this.genderOnId = event;
  }

  DateofBirth(dob) {
    // let dd = new Date(dob);
    // let date = dd.getDate() + "";
    // let month = dd.toLocaleString("en-US", { month: "short" })
    // let year = dd.getFullYear();
    // dob = (date.length == 1 ? '0' + date : date) + " " + month + " " + year;
    this.selectedDob = dob;
  }

  getCitiesData() {
    //To get the cities data
    this.citiesData = [];
    this.loadingFlag = true;
    this.ITDoseService.getCitiesForITDose().subscribe((res: any) => {
      if (res.response && res.response.length > 0) {
        this.citiesData = res.response;
      }
      else {
        this.citiesData = [];
        this.messageService.showErrorMessage("No data found");
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  getCitiesOnId(event) {
    //based on the cityId & stateId we will get the areas & pincode
    this.cityId = event;
    let stateId = this.citiesData.filter(d => {
      if (d.cityId == this.cityId) {
        return true;
      }
    });
    if (stateId.length == 1) {
      this.stateId = +stateId[0].stateId;
    }
    this.getAreaPincodeData();
    this.ITDoseForm.patchValue({Area: "", Location: "", Address: "", Test: "", Price: ""});
    this.testDetails = [];
    this.ViewselectedPackage = false;
  }

  getAreaPincodeData() {
    this.cityNameData = this.citiesData.filter(d => {
      if (d.cityId == this.cityId) {
        return true;
      }
    })
    //To get the area & pincode data based on cityId & stateId
    this.loadingFlag = true;
    this.areaPincodeData = [];
    this.ITDoseService.getAreasOnCity(this.cityNameData[0].stateId, this.cityNameData[0].cityId).subscribe((res: any) => {
      if (res.response && res.response.length > 0) {
        this.areaPincodeData = res.response;
      }
      else {
        this.areaPincodeData = [];
        this.messageService.showErrorMessage("No data found");
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  getAreaOnId(event) {
    this.areaId = event;
  }

  search(event) {
    if (this.cityId) {
      this.cityNameData = this.citiesData.filter(d => {
        if (d.cityId == this.cityId) {
          return true;
        }
      })
    }
    else {
      this.messageService.showErrorMessage("Please select city..!");
      return;
    }
    //when user type the location name immediately fetches the location suggestions.
    this.loadingFlag = true;
    let search = event.query;
    this.ITDoseService.getGoogleLocations(search).subscribe((res: any) => {
      if (res.response) {
        this.googlePlaces = res.response;
      }
      else {
        this.googlePlaces = [];
        this.messageService.showErrorMessage("No places found");
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  onSelect(event) {
    //when user selects the location from the dopdown will get the longitude & latitude details
    this.loadingFlag = true;
    this.address = event;
    this.ITDoseService.getGeoCodeDetails(this.address).subscribe((res: any) => {
      if (res.response && res.response['results'].length > 0) {
        let geoCodeDetails = res.response['results'][0].geometry;
        this.locationDetails = geoCodeDetails.location;
      }
      else {
        this.messageService.showErrorMessage("No data found!");
        this.locationDetails = "";
      }
      this.CheckAreaService();
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    });
  }

  CheckAreaService() {
    //To check whether selected location is in service or not
    this.loadingFlag = true;
    let payload = {
      "lat": this.locationDetails ? this.locationDetails.lat : "",
      "lng": this.locationDetails ? this.locationDetails.lng : "",
      "cityName": this.cityNameData[0].city,
    }
    this.ITDoseService.CheckAreaServiceability(payload).subscribe((res: any) => {
      if (res && res.response && res.response['isServiceable']) {
        this.CheckAreaServiceabilityDetails = res ? res.response : "";
        this.getAllPackages();
        this.ITDoseForm.get('TestDate').enable();
        this.ITDoseForm.get('Slot').enable();
      }
      else {
        this.messageService.showErrorMessage("selected location is not in serviceability");
        this.address = this.CheckAreaServiceabilityDetails = "";
        this.ITDoseForm.patchValue({ Location: "" });
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  getAllPackages() {
    //To get the test/packages data based on cityId & stateId
    this.loadingFlag = true;
    this.packagesData = [];
    this.dropdowntests = [];
    this.ITDoseService.getPackages(this.CheckAreaServiceabilityDetails ? this.CheckAreaServiceabilityDetails.stateId : "", this.CheckAreaServiceabilityDetails ? this.CheckAreaServiceabilityDetails.cityId : "").subscribe((res: any) => {
      if (res.response && res.response.length > 0) {
        this.packagesData = res.response;
        let packageObj = [];
        packageObj.push({ label: 'All', value: "" })
        res.response.forEach(function (item) {
          packageObj.push({ label: item.itemname, value: item.itemname })
        });
        this.dropdowntests = packageObj;
      }
      else {
        this.packagesData = [];
        this.dropdowntests = [];
        this.messageService.showErrorMessage("No packages found");
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  getPriceOnTestId(event) {
    //debugger;
    this.totalPrice = 0;
    this.packageItemTestsData = [];
    this.testDetails = [];
    this.packageItemTestsData = event.value;
    for (const data of this.packageItemTestsData) {
      //this.totalPrice = this.totalPrice + data.ScheduleRate > 0 ? data.ScheduleRate : data.Rate;
      if(data.ScheduleRate > 0){
        this.totalPrice = this.totalPrice + data.ScheduleRate
      }
      else{
        this.totalPrice = this.totalPrice + data.Rate
      }

      this.testDetails.push({
        "DiscAmt": 0,
        "itemid": data.itemid,
        "ItemName": data.itemname,
        "Itemtype": data.ItemType,
        "NetAmt": data.ScheduleRate > 0 ? data.ScheduleRate : data.Rate,
        "PaidAmt": 0,
        "Rate": data.ScheduleRate > 0 ? data.ScheduleRate : data.Rate,
        "SubCategoryID": data.subcategoryid,
        "TestCode": data.itemcode,
        "Coupon_DiscAmt_247": 0,
        "GroupPlan_DiscAmt_247": 0,
        "GroupPlan_247": ""
      })
    }

    if (this.testDetails.length > 0) {
      this.ViewselectedPackage = true;
    }
    else {
      this.ViewselectedPackage = false;
    }

    this.ITDoseForm.patchValue({ Price: this.totalPrice });
    this.ITDoseForm.get("Price").disable();
  }

  delete(i) {
    this.viewPackagesTotalPrice = 0;
    this.packageItemTestsData.splice(i, 1);
    this.testDetails.splice(i, 1);
    for (const data of this.packageItemTestsData) {
      this.viewPackagesTotalPrice = this.viewPackagesTotalPrice + data.Rate + data.ScheduleRate;
    }
    this.totalPrice = this.viewPackagesTotalPrice;
    this.ITDoseForm.patchValue({ Price: this.viewPackagesTotalPrice });
    this.ITDoseForm.get("Price").disable();
    this.getAllPackages();
  }

  testDate(apptDate) {
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = (dd.getMonth() + 1) + "";
    let monthShort = dd.toLocaleString("en-US", { month: "short" })
    let year = dd.getFullYear();
    apptDate = year + '-' + (month.length == 1 ? '0' + month : month) + '-' + (date.length == 1 ? '0' + date : date);
    this.selectedSlotDateForAppt = (date.length == 1 ? '0' + date : date) + "-" + monthShort + "-" + year;
    this.selectedAppointmentDate = apptDate;
    this.getAvailableSlots();
  }

  getAvailableSlots() {
    //To get the slots based on the location and the date selected
    let payload = {
      "Latitude": this.locationDetails ? this.locationDetails.lat : "",
      "Longitude": this.locationDetails ? this.locationDetails.lng : "",
      "Date": this.selectedAppointmentDate,
    }
    this.loadingFlag = true;
    this.ITDoseService.getAvailableSlots(payload).subscribe((res: any) => {
      this.allSlotsData = [];
      this.slotsData = res.response;
      if (this.slotsData["morning"] && this.slotsData["morning"].length > 0) {
        this.allSlotsData = this.allSlotsData.concat(this.slotsData["morning"]);
      }
      if (this.slotsData["noon"] && this.slotsData["noon"].length > 0) {
        this.allSlotsData = this.allSlotsData.concat(this.slotsData["noon"]);
      }
      if (this.slotsData["evening"] && this.slotsData["evening"].length > 0) {
        this.allSlotsData = this.allSlotsData.concat(this.slotsData["evening"]);
      }
      this.loadingFlag = false;
    }, error => {
      this.messageService.showError();
    })
  }

  getSlotsOnId(event) {
    this.patientDetails = [];
    this.slotsReq = [];
    this.slotsOnId = event;
    this.patientDetails.push({
      "patientName": this.isNewUser ? this.ITDoseForm.value.FirstName + " " + this.ITDoseForm.value.LastName : this.selectedUHIDDetails['firstName'] + " " + this.selectedUHIDDetails['lastName'],
      "uhid": this.isNewUser ? "" : this.selectedUHIDDetails['uhidNumber']
    });

    for (const data of this.allSlotsData) {
      if (data.slotId == this.slotsOnId) {
        this.slotsReq.push({
          "Time": data.slotTime,
          "PatientDetails": this.patientDetails,
        })
      }
    }
  }


  submitBtnDisable: boolean = false;
  bookAppointmentForITDose() {
    //To book the appointment in the  IT Dose Form
    if (this.ITDoseForm.valid) {
      this.ITDoseForm.enable();
      this.submitBtnDisable = true;
      let formDetails = this.ITDoseForm.value;
      let dd = new Date(formDetails.DateOfBirth);
      let date = dd.getDate() + "";
      let monthShort = dd.toLocaleString("en-US", { month: "short" })
      let year = dd.getFullYear();
      let DOBSelectedDate = (date.length == 1 ? '0' + date : date) + " " + monthShort + " " + year;
      let slotTimeDetails = this.allSlotsData.filter(d => {
        if (d.slotId == this.slotsOnId) {
          return true;
        }
      })

      this.areaPincodeDetails = this.areaPincodeData.filter(d => {
        
        if (this.areaId == d.areaId) {
          return true;
        }
      })
      let payload = {
        "BlockSlotsRequest": {
          "Lat": this.locationDetails ? this.locationDetails.lat : "",
          "Lng": this.locationDetails ? this.locationDetails.lng : "",
          "Address": formDetails.Address ? this.address : "",
          "SlotDate": this.selectedAppointmentDate,
          "Mobile": formDetails.MobileNumber,
          "Slots": this.slotsReq,
        },
        "BookITDoseAppointmentRequest": {
          "Patient_ID": this.isNewUser ? "" : this.selectedUHIDDetails['uhidNumber'],
          "PreBookingID_Primary": "",
          //"CreatedBy": this.userName,
          "Title": formDetails.salutation,
          "PName": formDetails.FirstName + " " + formDetails.LastName,
          "Gender": formDetails.Gender,
          "DOB": DOBSelectedDate,
          "Mobile": formDetails.MobileNumber ? formDetails.countryCode + "" + formDetails.MobileNumber : "",
          "Alternatemobileno": formDetails.AlternateMobileNumber ? formDetails.countryCode + "" + formDetails.AlternateMobileNumber : "",
          "Email": formDetails.Email,
          "Pincode": this.areaPincodeDetails ? this.areaPincodeData[0].pincode : "",
          "House_No": formDetails.Address ? formDetails.Address + "," + formDetails.Location : formDetails.Location,
          "Landmark": formDetails.Location ? formDetails.Location : "",
          "Appdatetime": this.selectedSlotDateForAppt + " " + slotTimeDetails[0].slotTime,
          "Paymentmode": "Cash",
          "Latitude": this.locationDetails ? this.locationDetails.lat : "",
          "Longitude": this.locationDetails ? this.locationDetails.lng : "",
          "ReferedDoctor": "Self",
          "DoctorID": 0,
          "TestDetail": this.testDetails,
          "IsPaid": 0,
          "AttachmentData": [],
          "CouponCode_247": "",
          "LocalityID_Serviceable": this.areaPincodeDetails ? this.areaPincodeDetails[0].areaId :this.areaId,
        },
        "Remarks" : formDetails.Remarks ? formDetails.Remarks : "", 
        "StateId" : this.stateId,
        "LeadAutoId": this.leadId,
        "CallerAutoId": +this.callerStatusAutoId,
        "CallStatusId": +this.selectedCallStatusId,
        "IsActivityLead": false,
      }
      this.loadingFlagAppt = true;
      this.ITDoseService.BookAppointmentForDiagnostics(payload).subscribe((res: any) => {
        if (res.isSuccess) {
          this.callCenterService.afterCompleteOperationKnowTheStatus({
            "callStatusId": this.selectedCallStatusId,
            "callStatusName": this.selectedCallStatusName,
            "isOperationDone": true,
            "statusMessage": "Test Booked Successfully."
          });
          this.messageService.showSuccess("Test Booked Successfully");
          this.submitBtnDisable = false;
        }
        else {
          this.submitBtnDisable = false;
          this.messageService.showErrorMessage(res.message);
        }
        this.loadingFlagAppt = false;
      }, error => {
        this.messageService.showError();
      });
    }
    else {
      this.messageService.showErrorMessage("Please fill in the details..!");
    }

  }

}
